import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { teamCoverageQuery } from '../../api/queries';
import { TeamPage } from '../../features/team/TeamPage';
import { COVER_FILTERS } from '../../features/team/team-model';

// The filter and the area open in the side panel live in the URL, so a link or a reload keeps them.
const search = z.object({
  filter: z.enum(COVER_FILTERS).optional().catch(undefined),
  // The router reads "?area=1.4" as a number; links the app writes quote it. Both are an area id.
  area: z.coerce
    .string()
    .regex(/^\d+\.\d+$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_app/team')({
  validateSearch: search,
  loader: ({ context }) => context.queryClient.query(teamCoverageQuery),
  component: function TeamRoute() {
    const { filter, area } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <TeamPage
        filter={filter ?? 'all'}
        areaId={area}
        onChange={(next) => {
          void navigate({
            search: { filter: next.filter === 'all' ? undefined : next.filter, area: next.areaId },
            replace: true,
            resetScroll: false,
          });
        }}
      />
    );
  },
});
